import React from 'react'
import { graphql } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import Layout from '../components/layout'
import Head from '../components/head'
import Hero from '../components/Hero'
import Form from '../components/form'

export const query = graphql`
  query($slug: String!) {
    contentfulPage(slug: { eq: $slug }) {
      titre
      text {
        json
      }

      image {
        fluid(maxWidth: 1920) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      isForm
      metaDescription
      metaTitle
    }
  }
`

const Page = ({ data }) => {
  return (
    <Layout>
      <Head
        title={data.contentfulPage.metaTitle}
        description={data.contentfulPage.metaDescription}
      />
      <div className="full-width">
        <Hero
          className="hero"
          imageData={data.contentfulPage.image.fluid}
          title={data.contentfulPage.titre}
        />
      </div>
      <section className="padding full-width bg-light-gray">
        <div className="grid-container">
          <div className="mb-2">
            {documentToReactComponents(data.contentfulPage.text.json)}
          </div>
          {data.contentfulPage.isForm && <Form />}
        </div>
      </section>
    </Layout>
  )
}

export default Page
